interface Props {
  compact?: boolean;
}

/** Text wordmark for dark/navy surfaces (no logo plate). */
export function BrandMark({ compact }: Props) {
  return (
    <span className={`brand-mark ${compact ? 'brand-mark--compact' : ''}`}>
      <span className="brand-mark__scrub">Scrub</span>
      <span className="brand-mark__ledger">Ledger</span>
    </span>
  );
}
